import { reactive } from 'vue';
import { configuracoesService } from '../service/configuracoes-service';

export const configuracoesStore = reactive({
    isLoading: false,
    isReady: false,
    GerarBaixaPorLeitura: false,
    hasTokenIntegracaoWhatsapp: false,

    async carregarConfiguracoes() {
        if (this.isReady || this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.isReady = false; 

         try {
            const configs = await configuracoesService.adquirirConfiguracoes();
            this.GerarBaixaPorLeitura = configs.GerarBaixaPorLeitura;
            this.hasTokenIntegracaoWhatsapp = configs.hasTokenIntegracaoWhatsapp;
            this.isReady = true;
        } catch (error) {
            console.error("Erro ao carregar configurações:", error);
        } finally {
            this.isReady = false;
            this.isLoading = false;
        }
    }
})